module.exports = __webpack_public_path__ + "img/1.3902f9e5.jpg";